<template>
  <span ref="container" v-bind="$attrs">
      <template v-if="contact">{{ contact }}</template>
      <slot v-else />
  </span>
</template>

<script>
import VueCookies from 'vue-cookies';

function decodePayload(encoded) {
    if (!encoded) {
        return {};
    }
    try {
        const raw = decodeURIComponent(escape(atob(encoded)));
        const rot13 = raw.replace(/[a-zA-Z]/g, (c) =>
            String.fromCharCode(c.charCodeAt(0) + (c.toLowerCase() <= 'm' ? 13 : -13))
        );
        return JSON.parse(rot13);
    } catch (e) {
        return {};
    }
}

let countryPromise = null;

export async function getIpCountry() {
    const cached = VueCookies.get('ipCountry');
    if (cached) {
        return cached;
    }

    if (!countryPromise) {
        countryPromise = fetch('https://api.country.is')
            .then((r) => r.json())
            .then((json) => {
                if (json?.country) {
                    VueCookies.set('ipCountry', json.country);
                    return json.country;
                }
                return null;
            })
            .catch(() => null);
    }

    return countryPromise;
}

export default {
    props: {
        locale: String,
        type: String,
        contacts: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            contact: null
        };
    },
    computed: {
        resolvedContacts() {
            return decodePayload(this.contacts);
        },
    },
    async mounted () {
        this.$refs.container.classList.add('swapping');
        const ipContact = await this.ipContact();

        if (ipContact) {
            this.contact = ipContact;
        }
        
        this.$nextTick(() => this.$refs.container.classList.remove('swapping'));
    },

    methods: {
        async ipContact() {
            const country = await getIpCountry();
            if (!country) {
                return null;
            }

            const contacts = this.resolvedContacts;
            const locale = Object.keys(contacts).find((k) => k.endsWith(country.toUpperCase()));

            return locale ? (contacts[locale] ?? null) : null;
        },
    }
}
</script>
